<template>
    <div class="dynamic-form">
        <vue-form>
            <template v-if="wrap">
                <div v-for="formElement in formElements" class="vue-form-row">
                    <vue-input v-for="element in formElement"
                        :element="element"
                        :tabindex="element.position">
                    </vue-input>
                </div>
            </template>

            <template v-else>
                <div v-for="element in formElements" class="vue-form-row">
                    <vue-input
                        :element="element"
                        :tabindex="element.position">
                    </vue-input>
                </div>

                <div class="vue-form-row has-multiple-elements">
                    <vue-input v-for="action in formActions"
                        :element="{
                            'attributes': action
                        }">
                    </vue-input>
                </div>
            </template>
        </vue-form>
    </div>
</template>

<script src="./dynamic-form.js"></script>
